// extracted by mini-css-extract-plugin
export default {"content":"styles_content__gjDkd","message":"styles_message__pSzIz","title":"styles_title__H4h4P","description":"styles_description__PiEXk","btnBar":"styles_btnBar__p4o+X"};